import { environment } from '../environments/environment';

/*  A BELÉPÉS UTÁNI / INDULÁSKORI KEZDŐOLDAL.
 *
 *  A feladatellátás `kezdourl`-je egy alrendszer képernyője is lehet (TAXI-TAX: /naplo/ugyfelek). Ha a
 *  program MÁS alrendszerben fut – a BÉR és a Tárgyi eszköz asztali programja fixált alrendszerrel
 *  indul –, azt nem nyithatjuk meg: a bér-program a Könyvelést mutatta (user, 2026-10-07). Ilyenkor
 *  az alrendszer saját kezdőoldala nyílik. A landing és az AppComponent belépési ága is ezt használja.
 */
const MOD_UT: Record<string, string> = { NAPLO: '/naplo', BER: '/ber', ESZKOZ: '/eszkoz', SZAMLAZO: '/szamlazo', INVENTARIO: '/inventario', GEPJARMU: '/gepjarmu', IKTATGATO: '/iktatgato' };

export function kezdoUrl(kezdourl: string | null | undefined, mod: string | null | undefined): string {
  const ut = String(kezdourl || '').trim();
  const alatt = (p: string) => ut === p || ut.startsWith(p + '/') || ut.startsWith(p + '?');
  //  Fixált alrendszerű (asztali / mobil) programban mindig az az alrendszer dönt.
  const m = String((environment as any).fixedMode || mod || '').toUpperCase();
  const sajat = MOD_UT[m];
  if (sajat) return alatt(sajat) ? ut : sajat;
  //  Alrendszer-képernyő nélküli mód (SULINFORM stb.): másik alrendszer képernyője nem lehet a kezdőoldal.
  return ut && !Object.values(MOD_UT).some(alatt) ? ut : '/home';
}
